// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2jNvR","icon":"SortAdornment_icon__2b90G","up":"SortAdornment_up__3C2Xx","down":"SortAdornment_down__3UhNW","active":"SortAdornment_active__37BiP"};